import type { AppDispatch } from "@store/store";
import { queryClient } from "@providers/QueryProvider";
import { resetConfig } from "@store/slices/configSlice";
import { clearCourseDetails } from "@store/slices/courseDetailsSlice";
import { resetMultiCourseFlow, clearSelectedCourses, clearAddedCourses } from "@store/slices/courseSlice";
import { clearInstituteData } from "@store/slices/instituteSlice";
import { resetRenewalCourses } from "@store/slices/renewalCoursesSlice";
import { resetRegisterInstituteForm } from "@store/slices/registerInstituteFormSlice";
import { clearFormData as clearCourseDetailsFormData } from "@store/slices/courseDetailsFormSlice";
import { resetReferback } from "@store/slices/referbackSlice";
import { clearApplications } from "@store/slices/applicationsSlice";

/**
 * Clears all persisted registration/application draft state.
 * Use on login, logout, and when starting a brand-new institute registration.
 */
export function clearRegistrationSessionState(dispatch: AppDispatch): void {
	queryClient.clear();
	dispatch(resetConfig());
	dispatch(clearCourseDetails());
	dispatch(resetMultiCourseFlow());
	dispatch(clearSelectedCourses());
	dispatch(clearAddedCourses());
	dispatch(clearInstituteData());
	dispatch(resetRenewalCourses());
	dispatch(resetRegisterInstituteForm());
	dispatch(clearCourseDetailsFormData());
	dispatch(resetReferback());
	dispatch(clearApplications());
}
